const CONTACT_URL = 'https://www.prodyt.com/contact';

export const hasFeature = (capabilities, featureName) => {
    const features = capabilities?.context?.features;
    if (!Array.isArray(features)) {
        return false;
    }
    return features.includes(featureName);
};

export const hasModule = (capabilities, moduleName) => {
    const modules = capabilities?.context?.modules;
    if (!Array.isArray(modules)) {
        return false;
    }
    return modules.includes(moduleName);
};

export const getAccessFeatures = (capabilities) => {
    const accessFeatures = capabilities?.context?.accessFeatures;
    return Array.isArray(accessFeatures) ? accessFeatures : [];
};

export const hasAccessFeature = (capabilities, feature) => {
    const accessFeatures = getAccessFeatures(capabilities);
    return accessFeatures.includes(feature);
};

export const hasActivePlan = (capabilities) => {
    const planIds = capabilities?.context?.planIds;
    return Array.isArray(planIds) && planIds.length > 0;
};

export const getPlanIds = (capabilities) => {
    const planIds = capabilities?.context?.planIds;
    return Array.isArray(planIds) ? planIds : [];
};

export const getFeaturesByModule = (capabilities, modulePrefix) => {
    const features = capabilities?.context?.features;
    if (!Array.isArray(features)) {
        return [];
    }
    const prefix = modulePrefix.toLowerCase();
    return features.filter(feature =>
        typeof feature === 'string' && feature.toLowerCase().startsWith(prefix + '.')
    );
};

export const getLimit = (capabilities, limitName) => {
    return capabilities?.context?.limits?.[limitName] ?? null;
};

export const hasCRM = (capabilities) => {
    return hasModule(capabilities, 'CRM');
};

export const hasWhatsApp = (capabilities) => {
    return hasModule(capabilities, 'WHATSAPP');
};

export const isAuthorized = (capabilities) => {
    return capabilities?.isAuthorized === true;
};

export const getAllFeatures = (capabilities) => {
    return capabilities?.context?.features || [];
};

export const getAllModules = (capabilities) => {
    const modules = capabilities?.context?.modules;
    if (!Array.isArray(modules)) {
        return [];
    }
    return modules;
};

export const getSubscriptionStatus = (capabilities, module) => {
    const subscriptions = capabilities?.context?.subscriptions;
    if (!Array.isArray(subscriptions)) {
        return null;
    }
    return subscriptions.find(sub => sub.module === module) || null;
};

export const getUsageStats = (capabilities, module) => {
    return capabilities?.usage?.[module] || null;
};

export const getAlerts = (capabilities) => {
    return capabilities?.alerts || [];
};

export const getLegacyEntitlements = (capabilities) => {
    const modules = capabilities?.context?.modules;
    
    if (!Array.isArray(modules) || modules.length === 0) {
        return [];
    }
    
    return modules.map(module => ({
        product: module,
        status: 'ACTIVE'
    }));
};

export const getNoModulesMessage = () => {
    return {
        title: 'No Modules Assigned',
        message: 'You don\'t have any modules assigned yet. Please contact support to get started.',
        contactUrl: CONTACT_URL,
        buttonText: 'Contact Support'
    };
};
